import React from 'react';
import PropTypes from 'prop-types';
import {createFragmentContainer, graphql} from 'react-relay';
import {Dropdown, HexagonText} from '@/web-components';

export const clientContactOptionLabel = node => {
	const fullName = `${node.firstName || ''} ${node.lastName || ''}`.trim();
	const clientName = node.client && node.client.name ? node.client.name : '';
	return clientName ? `${fullName} - ${clientName}` : fullName;
};

export const ClientContactDropdown = ({
	clientContacts,
	emphasizeEmptyState,
	dropdownAlignment,
	width,
	name,
	selectedItems,
	onRemove,
	onSelect,
	optionsName,
	selectedGroupName,
	userpilot,
	isClearable,
	customPlaceholder,
	isNested,
	isMultiSelect,
	headerLines,
	cy,
}) => {
	const sortedContacts = [...clientContacts].sort((a, b) => {
		if (a.node.id === null) return -1;
		if (b.node.id === null) return 1;
		return clientContactOptionLabel(a.node).toLowerCase().localeCompare(clientContactOptionLabel(b.node).toLowerCase());
	});
	return (
		<Dropdown
			isNested={isNested}
			isMultiSelect={isMultiSelect}
			headerLines={headerLines}
			onSelect={onSelect}
			onRemove={onRemove}
			selectedGroupName={selectedGroupName}
			selectedItems={selectedItems}
			width={width}
			dropdownAlignment={dropdownAlignment}
			name={name}
			userpilot={userpilot}
			emphasizeEmptyState={emphasizeEmptyState}
			isClearable={isClearable}
			customPlaceholder={customPlaceholder}
			cy={cy}
		>
			<Dropdown.Group name={optionsName} key={'client-contact-group'}>
				{sortedContacts.map(edge => {
					const label = clientContactOptionLabel(edge.node);
					return <HexagonText key={edge.node.id} value={edge.node.id} searchString={label} text={label} />;
				})}
			</Dropdown.Group>
		</Dropdown>
	);
};

ClientContactDropdown.propTypes = {
	clientContacts: PropTypes.arrayOf(
		PropTypes.shape({
			node: PropTypes.shape({
				id: PropTypes.string.isRequired,
				firstName: PropTypes.string,
				lastName: PropTypes.string,
				client: PropTypes.shape({name: PropTypes.string}),
			}),
		})
	).isRequired,
	dropdownAlignment: PropTypes.oneOf(['left', 'center', 'right']),
	width: PropTypes.number,
	name: PropTypes.string,
	optionsName: PropTypes.string,
	selectedItems: PropTypes.array,
	onSelect: PropTypes.func,
	onRemove: PropTypes.func,
	selectedGroupName: PropTypes.string,
	headerLines: PropTypes.element,
};

ClientContactDropdown.defaultProps = {
	optionsName: 'Contact',
	name: 'Contacts',
	selectedGroupName: 'Selected',
	onSelect: () => false,
	onRemove: () => false,
	isNested: true,
	isMultiSelect: true,
};

export default createFragmentContainer(ClientContactDropdown, {
	clientContacts: graphql`
		fragment ClientContactDropdown_clientContacts on ClientContactEdge @relay(plural: true) {
			node {
				id
				firstName
				lastName
				client {
					id
					name
				}
			}
		}
	`,
});
